import { Observable } from 'rxjs';
import { StateObservable, ofType } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { CreateOwnershipSuccess } from '@webapp/store/ownership/action-creators';
import { CREATE_OWNERSHIP_SUCCESS } from '@webapp/store/ownership/actions';
import { rudderTrack } from '@webapp/utils/rudderstack/init';
import AppState from '@webapp/store/state';
import {
  fieldToIndexMap,
  releaseStepNameFromIndexMap,
} from '@webapp/utils/release/constants';

export const trackOwnerAdded = (
  action$: Observable<CreateOwnershipSuccess>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(CREATE_OWNERSHIP_SUCCESS),
    filter((action) => action.ownership.assetType === 'TRACK'),
    withLatestFrom(state$),
    map(([action, state]) => {
      if (window.analytics) {
        window.analytics.track('Collaborator Added', {
          id: action.ownership.id,
          assetId: action.ownership.assetId,
          assetType: action.ownership.assetId,
          collaborator: {
            id: action.ownership.ownerId,
            name: action.ownership.name,
            type: action.ownership.ownerType,
          },
          type:
            action.ownership.ownershipType === 'OWNER' ? 'Owner' : 'Songwriter',
        });
      }
      const field =
        action.ownership.ownershipType === 'OWNER' ? 'Owners' : 'Songwriters';
      const track = state.tracks.tracks[action.ownership.assetId];
      const stepIndex = 4;
      const stepName = releaseStepNameFromIndexMap[stepIndex];
      const fieldIndex = fieldToIndexMap[field];
      const trackIndex = track ? track.order : undefined;

      const ownerships = Object.values(
        state.ownership.assets[action.ownership.assetId]
      );

      rudderTrack('Release step completed', {
        artist_id: state.artist.active?.id,
        artist_name: state.artist.active?.name,
        step_index: stepIndex,
        step_name: stepName,
        release_id: state.release.release?.id,
        release_name: state.release.release?.title,
        field_index: fieldIndex,
        field_name: field,
        field_value: ownerships.filter(
          (owner) => owner.ownershipType === action.ownership.ownershipType
        ),
        track_index: trackIndex,
      });
    }),
    filter(() => false)
  );
